import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import FormInputs from './FormInputs';

export default function QuickCustomerModal({ addCustomerShow, addCustomerClose }) {

    const initialInputData = {
        name: '',
        email: '',
        phone_number2: '',
        gender: 'Male',
        birth_date: null,
        anniversary_date: null,
        address: null,
        reffered_by_id: 0,
        gst: 'NA',
        country: 0,
        state: 0,
        city: 0,
        tax: 0,
        pan: null,
        opening_balance: 0.0,
        bank_name: 0,
        ifsc_code: null,
        account_number: 'NA',
    };

    const [inputData, setInputData] = useState(initialInputData);

    const handleInputChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        addCustomerClose();
    };

    const rows = [
        {
            columns: [
                { size: { lg: 6 }, label: 'Customer Name', type: 'text', name: 'name', id: 'name', placeholder: 'Enter name...', value: inputData.name, errormsg: '', },
                { size: { lg: 6 }, label: 'Mobile Number', type: 'number', name: 'phone_number2', id: 'phone_number2', placeholder: 'Enter number...', value: inputData.phone_number2, errormsg: '', },
                { size: { lg: 12 }, label: 'Email', type: 'email', name: 'email', id: 'email', placeholder: 'Enter email...', value: inputData.email, errormsg: '', },
                {
                    size: { sm: 6 }, label: 'Gender', type: 'select', name: 'gender', id: 'gender', value: inputData.gender, errormsg: '',
                    options: [
                        { value: '', label: 'Select Gender' },
                        { value: 'Male', label: 'Male' },
                        { value: 'Female', label: 'Female' },
                        { value: 'Other', label: 'Other' },
                    ],
                },
                { size: { lg: 6 }, label: 'Birthday', type: 'date', name: 'birth_date', id: 'birth_date', placeholder: 'DD/MM/YYYY', value: inputData.birth_date, errormsg: '', },
            ]
        }
    ];
    const Buttons = [
        { variant: "primary", text: "Add", onClick: handleSubmit },
        { variant: "secondary", text: "Cancel", onClick: addCustomerClose },
    ]

    return (
        <>
            <Modal centered show={addCustomerShow} onHide={addCustomerClose} size='lg'>
                <Modal.Header className='custom-close-btn' closeButton></Modal.Header>
                <Modal.Body>
                    <h5 className='mb-4'>Add New Customer</h5>
                    <FormInputs Buttons={Buttons} rows={rows} handleInputChange={handleInputChange} handleSubmit={handleSubmit} />
                </Modal.Body>
            </Modal>
        </>
    )
}
